<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M3 14.5H14" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M5.5 14.5V2.5H9.5V14.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round"/>
  <rect x="6.3" y="5" width="2.4" height="7.5" rx="0.4" fill="#E5E5E5"/>
  <path d="M9.5 3H12.5V6" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
  <circle cx="12.5" cy="7.5" r="1.3" fill="#E5E5E5"/>
</svg>
